// React
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// Styles
import '../styles/AddCardPopUp.css';

// Components
import MissionHeader from './MissionHeader';
import MainButton from './MainButton';
import InputNumber from './InputNumber';

// Data
import { contentData } from '../assets/data/contentData';

// Props du composant AddCardPopUp
type AddCardPopUpProps = {
    setIsAddCardOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

// Composant pour la popup d'ajout de carte machine
// Cette popup prend toute la place de l'écran
// Permet de saisir le numéro de la carte machine et de naviguer vers l'écran approprié

const AddCardPopUp: React.FC<AddCardPopUpProps> = ({ setIsAddCardOpen }) => {
    const [cardNumber, setCardNumber] = React.useState<number>(0);
    const [showCardDoesNotExist, setShowCardDoesNotExist] = React.useState<boolean>(false);
    const [inputResetKey, setInputResetKey] = useState<number>(0);
    const navigate = useNavigate();
    const { missionNumber } = useParams<{ missionNumber: string }>();

    // Handler pour la validation du numéro de carte
    const handleValidate = () => {
        const numCard = Number(cardNumber);
        const mission = contentData.missions.find((m) => m.id === Number(missionNumber));

        if (!mission) {
            console.error('Mission introuvable');
            return;
        }

        // Vérifie si la carte existe dans les données de la mission
        if (mission.cartesMachineQuiz?.includes(numCard)) {
            // On va vers le quiz en passant le numéro de la carte
            navigate(`./quiz`, {
                state: {
                    cardNumber: numCard,
                },
            });
        } else if (mission.cartesMachineRoulete?.includes(numCard)) {
            // On va vers la roulette en passant le numéro de la carte
            navigate(`./code`, {
                state: {
                    cardNumber: numCard,
                },
            });
        } else if (mission.cartesMachineMap?.includes(numCard)) {
            // On va vers la map (bactéries) en passant le numéro de la carte
            navigate(`./map`, {
                state: {
                    cardNumber: numCard,
                },
            });
        } else if (mission.cartesMachineAR?.includes(numCard)) {
            navigate(`../../ar`, {
                state: {
                    cardNumber: numCard,
                },
            });
        } else if (mission.cartesMachinesTextTrou?.includes(numCard)) {
            navigate(`./texte-a-trous`, {
                state: {
                    cardNumber: numCard,
                },
            });
        } else if (mission.cartesMachineQuestion?.includes(numCard)) {
            navigate(`./question`, {
                state: {
                    cardNumber: numCard,
                },
            });
        } else if (mission.cartesMachinAscenseur?.includes(numCard)) {
            navigate(`../endgame`, {
                state: {
                    cardNumber: numCard,
                },
            });
        } else {
            // La carte n'existe pas, on affiche un message d'erreur
            setShowCardDoesNotExist(true);

            setTimeout(() => {
                // Cache le message d'erreur après 2 secondes
                setShowCardDoesNotExist(false);
                // Reset de l’input et du state
                setCardNumber(0);
                // Reset de la clé pour forcer le reset de l’input
                setInputResetKey((prev: number) => prev + 1);
            }, 2000);
        }
    };
    return (
        <div className='popup add-card-popup'>
            <div className='add-card-popup-gradient'></div>
            {/* Ajout du header de mission */}
            <MissionHeader
                showBackButton={false}
                showSettingsButton={false}
                showCloseButton={true}
                logoVariant='default'
                closeFunction={() => setIsAddCardOpen(false)}
                closeButtonVariant='white'
            />
            <p className='add-card-popup-text'>
                Saisissez<span>le numéro</span> de la carte <b>machine</b>
                <img
                    src='./images/card-image.png'
                    alt='Card Icon'
                    className='add-card-info-icon'
                />
            </p>
            <div className='input-group add-card-input-group '>
                <p className={`error-message ${showCardDoesNotExist ? 'visible' : ''}`}>
                    Ce n'est pas un carte machine valide.
                </p>
                {/* Ajout du composant InputNumber pour saisir le numéro de carte machine */}
                <InputNumber
                    key={inputResetKey}
                    setValue={setCardNumber}
                    tensInitialValue={0}
                    onesInitialValue={0}
                    onEnter={handleValidate}
                />
            </div>

            {/* Ajout du composant boutton principal pour valider */}
            <MainButton
                text='Valider'
                backgroundColor={'secondary'}
                onClick={handleValidate}
                disabled={cardNumber === 0 || showCardDoesNotExist}
            />
            <div className='add-card-popup-gradient-2'></div>
        </div>
    );
};

export default AddCardPopUp;
